export const INITIAL_DATE_RANGE = {
    rangeType: 'custom_range',
    startDate: '',
    endDate: '',
    fieldType: 'dateRange'
};
export const INITIAL_FILTER_STATE = {
    accountIds: [],
    buildingIds: [],
    territoryIds: [],
    additionalTerritoryIds: [],
    systemIds: [],
    dateType: null,
    dateRange: INITIAL_DATE_RANGE,
    search: '',
    collapseGroups: true
};
